import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Button from '../components/Button';
import RecommendationCard from '../components/RecommendationCard';
import { mockRecommendations } from '../data/quizData';
import { tracker } from '../lib/tracker';
import { ROUTES } from '../config/urls';

const PlanPage: React.FC = () => {
  const navigate = useNavigate();
  const { token } = useParams<{ token?: string }>();

  const handleRdv = () => {
    if (token) {
      tracker.trackRdvPris(token);
      navigate(ROUTES.THANKS(token));
    } else {
      navigate(ROUTES.THANKS());
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="container mx-auto px-4 py-8 max-w-2xl">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">
          Votre plan d'action
        </h1>

        <div className="space-y-6 mb-12">
          {mockRecommendations.map((recommendation, index) => (
            <RecommendationCard
              key={index}
              title={recommendation.title}
              description={recommendation.description}
            />
          ))}
        </div>

        <div className="bg-gray-50 p-6 rounded-lg mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Planifier un appel stratégique
          </h2>
          <div className="bg-white p-4 rounded border h-[400px] flex items-center justify-center text-gray-500">
            Calendly iframe placeholder
          </div>
        </div>

        <div className="text-center">
          <Button onClick={handleRdv} icon>
            Prendre un rendez-vous
          </Button>
        </div>
      </main>
    </div>
  );
};

export default PlanPage;